import { render, staticRenderFns } from "./AdminQuotesAllScreen.vue?vue&type=template&id=483a1b76&scoped=true&"
import script from "./AdminQuotesAllScreen.vue?vue&type=script&lang=js&"
export * from "./AdminQuotesAllScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "483a1b76",
  null
  
)

export default component.exports